module.exports = __webpack_public_path__ + "img/laita_solider_down.df15b702.png";